import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  radioGroup: {
    flexDirection: "row",
  },
  item: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "15px",
    paddingTop: "15px",
    borderBottom: "1px solid #D3D3D3",
  },
  statusDot: {
    border: `1px solid ${theme.palette.success.main}`,
    borderRadius: "50%",
    width: "25px",
    height: "25px",
  },
  acceptedDot: {
    backgroundColor: theme.palette.success.main,
  },
  checkIcon: {
    color: "#fff",
    width: "90%",
  },
}))

export default useStyles
